import React, { useEffect, useState, useContext, useRef } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { Link } from "react-router-dom";
import "../../../index.css";
import { numberFormat } from "../../../config/numberFormat";
import ToggleSwitch from "../../../_toggleSwitch/toggleSwitch";
import { PostData } from "../../../service/postData";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import QuickAdjustAddNewTerms from "../userExpense/quickAddTerms";
import QuickAddNewParty from "../businessParty/quickPartyAdd";
import QuickAddNewBankDetail from "../cashBank/quickBankAdd";
import QuickAddNewPrefix from "../userSale/quickNewPrefixAdd";
import PurchaseAddItemTable from "./PurchaseAddItemTable";
import { Loader } from "@progress/kendo-react-indicators";
import TransactionCreateDialog from "../TransactionCreateDialog";
import { useLocation, useHistory } from 'react-router-dom';


const ManagePurchaseCreate = (props) => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const auth = queryParams.get('auth');
  const transactionType = queryParams.get('tType') ? queryParams.get('tType') : '';
  const isReadOnly = queryParams.get('readOnly') === 'true';
  // Read-only view of a saved duplicate copy (only changes the banner text)
  const isDuplicateCopyView = isReadOnly && queryParams.get('dup') === '1';
  const isConvert = transactionType == 'ORDER';
  const isDuplicate = transactionType == 'DUPLICATE';
  const [businessSetting, setBusinessSetting] = useState({});
  const [searchPartyName, setSearchPartyName] = useState('');
  const [partyId, setPartyId] = useState(0);
  const [partyName, setPartyName] = useState('');
  const [partyContactNo, setPartyContactNo] = useState('');
  const [partyRemainBalance, setPartyRemainBalance] = useState(0);
  const [billingName, setBillingName] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [poNumber, setPoNumber] = useState('');
  const [poDate, setPoDate] = useState(moment().format("YYYY-MM-DD"));
  const [EWayBillNo, setEWayBillNo] = useState('');
  const [paymentTermsData, setPaymentTermsData] = useState([]);
  const [dueOnDate, setDueOnDate] = useState(moment().format("YYYY-MM-DD"));
  const [termsId, setTermsId] = useState(0);
  const [prefixId, setPrefixId] = useState(1);
  const [prefixName, setPrefixName] = useState('');
  const [prefixArray, setPrefixArray] = useState([]);
  const [invoiceNo, setInvoiceNo] = useState(Math.floor(Math.pow(10, 5) + Math.random() * (Math.pow(10, 6) - Math.pow(10, 5) - 1)));
  const [invoiceDate, setInvoiceDate] = useState(moment().format("YYYY-MM-DD"));
  const [invoiceTime, setInvoiceTime] = useState(moment().format("hh:mm A"));
  const [stateArray, setStateArray] = useState([]);
  const [stateName, setStateName] = useState('');
  const [bankId, setBankId] = useState(-2);
  const [bankName, setBankName] = useState('');
  const [paymentType, setPaymentType] = useState('Cash');
  const [paymentRefNo, setPaymentRefNo] = useState('');
  const [description, setDescription] = useState('');
  const [descImage, setDescImage] = useState('');
  const refDescImage = useRef('');
  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const [transactionId, setTransactionId] = useState(0);
  const [isReverseCharge, setIsReverseCharge] = useState(false); 
  const [reverseChargeTax, setReverseChargeTax] = useState(0); 
  const [payableAmount, setPayableAmount] = useState(0); 
  const [printType, setPrintType] = useState('showall');
  const [totalTransDiscountPer, setTotalTransDiscountPer] = useState(0);
  const [totalTransDiscountAmount, setTotalTransDiscountAmount] = useState(0);
  const [taxRateArray, setTaxRateArray] = useState([]);
  const [transactionWiseTaxId, setTransactionWiseTaxId] = useState(0);
  const [totalTransTaxAmount, setTotalTransTaxAmount] = useState(0);
  const [totalTransTaxRatio, setTotalTransTaxRatio] = useState(0);
  const [transAdditionalCharge1, setTransAdditionalCharge1] = useState(0);
  const [transAdditionalCharge2, setTransAdditionalCharge2] = useState(0);
  const [transAdditionalCharge3, setTransAdditionalCharge3] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [itemSubTotalAmount, setItemSubTotalAmount] = useState(0);
  const [totalItemGstAmount, setTotalItemGstAmount] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalAdditionalCess, setTotalAdditionalCess] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [additionalValue1, setAdditionalValue1] = useState('');
  const [additionalValue2, setAdditionalValue2] = useState('');
  const [additionalValue3, setAdditionalValue3] = useState('');
  const [additionalValue4, setAdditionalValue4] = useState(moment().format("YYYY-MM-DD"));
  const [transportDetailField1, setTransportDetailField1] = useState('');
  const [transportDetailField2, setTransportDetailField2] = useState('');
  const [transportDetailField3, setTransportDetailField3] = useState('');
  const [transportDetailField4, setTransportDetailField4] = useState('');
  const [transportDetailField5, setTransportDetailField5] = useState('');
  const [transportDetailField6, setTransportDetailField6] = useState('');
  const [partyItemArray, setPartyItemArray] = useState([]);
  const [partyArray, setPartyArray] = useState([]);
  const [bankArray, setBankArray] = useState([]);
  const [companyId, setCompanyId] = useState(0);
  const [businessId, setBusinessId] = useState(0);
  const [signingId, setSigningId] = useState(0);
  const [countryName, setCountryName] = useState('');
  const [showPartyViewList, setShowPartyViewList] = useState(false);
  const [isDialogOpen_Time, setIsDialogOpen_Time] = useState(false);
  const [isDialogOpen_AddTerms, setIsDialogOpen_AddTerms] = useState(false);
  const [isDialogOpen_AddPrefix, setIsDialogOpen_AddPrefix] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [message, setMessage] = useState('');
  const [printTypeList, setprintTypeList] = useState([]);
  const [selectedItemArray, setSelectedItemArray] = useState([]);
  const [isItemSoldOut, setIsItemSoldOut] = useState(false);
  const [isReturn, setIsReturn] = useState(false);
  const [isMakePayment, setIsMakePayment] = useState(false);
  const [isChequeMakePayment, setIsChequeMakePayment] = useState(false);
  const [totalLinkHistoryAmt, setTotalLinkHistoryAmt] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDialogPreviewImage, setIsDialogPreviewImage] = useState(false);
  const [isDialogAddNewParty, setIsDialogAddNewParty] = useState(false);
  const [isDialogAddNewBank, setIsDialogAddNewBank] = useState(false);

  const handleKeyPress = (e) => {
    if (!/[0-9.]/.test(e.key)) {
      e.preventDefault();
    }
    const currentValue = e.target.value;
    const dotCount = (currentValue.match(/\./g) || []).length;
    
    if (e.key === '.' && dotCount >= 1) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    let dummyData = [
      { value: "showall", label: "Show All" },
      { value: "Original", label: "Original" },
      { value: "Duplicate", label: "Duplicate" },
      { value: "Triplicate", label: "Triplicate" },
    ]
    setprintTypeList(dummyData);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
          let _UserSession = localStorage.getItem("vs_UserSession");

          // Parse before accessing fields — the previous code read
          // `_UserSession.loginType` off the JSON string and then called
          // JSON.parse without a try/catch, so a corrupt session string
          // would throw and abort the whole effect silently.
          if (_UserSession) {
            try {
              _UserSession = JSON.parse(_UserSession);
            } catch (e) {
              _UserSession = null;
            }
          }
          if (_UserSession && _UserSession.loginType != "Admin") {
            {
              let _signingId = _UserSession.loginId;
              let _businessId = _UserSession.tokenKey;
              let _company_id = _UserSession.company_id;
              let _businessSetting = _UserSession.businessSetting || {};

              setSigningId(_signingId);
              setCompanyId(_company_id);
              setBusinessId(_businessId);
              setBusinessSetting(_businessSetting);

              if (_businessSetting.PrintOriginalDuplicate == 0) {
                setPrintType('');
              }
            }
          }
          let _companySession = localStorage.getItem("vs_UserCompanySession");
          if (_companySession) {
            try {
              _companySession = JSON.parse(_companySession);
            } catch (e) {
              _companySession = null;
            }
          }
          if (_companySession) {
            let _businessId = _companySession.business_id;
            let _company_id = _companySession.company_id;
            let _countryCode = _companySession.country_code;
            let _countryName = _companySession.country_name;
            // taxDetails can be missing/null for freshly-created
            // companies — treat as an empty list instead of crashing
            // the effect on .push.
            let _taxRateArray = Array.isArray(_companySession.taxDetails)
              ? [..._companySession.taxDetails]
              : [];
            let _company_Logo = _companySession.company_logo;


            setCompanyId(_company_id);
            setBusinessId(_businessId);
            setCountryName(_countryName);
            _taxRateArray.push({ id: 0, name: 'None', ratio: 0 });
            setTaxRateArray(_taxRateArray);

            getPartyListData(_company_id);
            getStateListData(_countryCode);
            await getTransactionDetails(_company_id, _businessId);
            getPaymentTerms(_company_id, _businessId);
          }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

  fetchData();

  }, []);

  const getTransactionDetails = async (company_id, businessId) => {
    if (auth) {
      setTransactionId(auth);
      setIsLoading(true);
      setIsEditMode(true);
      const requestData = JSON.stringify({
        transaction_id: auth,
      });
      const responseJson = await PostData(global.userPurchaseTransactionDetails, requestData, "POST")
      if (responseJson.success) {
        // Guard the shape defensively — a sparse row (e.g. missing
        // customer, missing totalSummary, items=null) would otherwise
        // throw inside this async function, which the outer fetchData
        // try/catch would swallow, leaving isLoading true and the
        // page effectively blank until the user reloads.
        let response = (responseJson.response && responseJson.response[0]) || {};
        let totalSummary = response.totalSummary || {};
        let prefix = response.prefix || {};
        let items = Array.isArray(response.items) ? response.items : [];
        let customer = response.customer || {};
        setPartyId(customer.party_id || 0);
        setPartyName(customer.party_name || '');
        setPartyContactNo(customer.party_contact_no || '');
        setBillingName(customer.billing_name || '');
        setBillingAddress(response.billing_address || '');
        setPartyRemainBalance(customer.partyBalance || 0);
        setPoNumber(response.po_number || '');
        setPoDate(response.po_date ? response.po_date : moment().format("YYYY-MM-DD"));
        setEWayBillNo(response.E_Way_Bill_No || '');
        // Empty invoiceDate → moment('').toDate() → Invalid Date, which
        // the DatePicker in the render below chokes on.
        setInvoiceDate(response.invoiceDate ? response.invoiceDate : moment().format("YYYY-MM-DD"));
        setInvoiceTime(response.invoice_time || moment().format("hh:mm A"));
        setStateName(response.countryState || '');
        setTotalTransDiscountPer(response.totalTransDiscountPer || 0);
        setTotalTransDiscountAmount(response.totalTransDiscountAmount || 0);
        setTransactionWiseTaxId(response.transactionWiseTaxId || 0);
        setTransAdditionalCharge1(response.TransAdditionalCharge1 || 0);
        setTransAdditionalCharge2(response.TransAdditionalCharge2 || 0);
        setTransAdditionalCharge3(response.TransAdditionalCharge3 || 0);
        setIsReverseCharge(!!totalSummary.reverseChargeStatus);
        setReverseChargeTax(totalSummary.reverseChargeTax || 0);
        const _paidAmt = parseFloat(totalSummary.paidAmount) || 0;
        const _recvAmt = parseFloat(totalSummary.receivedAmount) || 0;
        setPaidAmount(_paidAmt + _recvAmt);
        setDueAmount(parseFloat(totalSummary.dueAmount) || 0);
        setAdditionalValue1(response.additional_value_1 || '');
        setAdditionalValue2(response.additional_value_2 || '');
        setAdditionalValue3(response.additional_value_3 || '');
        setAdditionalValue4(response.additional_value_date || moment().format("YYYY-MM-DD"));
        setTransportDetailField1(response.TransportDetailField1 || '');
        setTransportDetailField2(response.TransportDetailField2 || '');
        setTransportDetailField3(response.TransportDetailField3 || '');
        setTransportDetailField4(response.TransportDetailField4 || '');
        setTransportDetailField5(response.TransportDetailField5 || '');
        setTransportDetailField6(response.TransportDetailField6 || '');
        setBankId(response.bankId != null ? response.bankId : -2);
        setBankName(response.bankName || '');
        setPaymentType(response.paymentType || 'Cash');
        setPaymentRefNo(response.paymentRefNo || '');
        setDescription(response.description || '');
        setImagePreviewUrl(response.descImage ? (response.urlImg + response.descImage) : '');
        setPrintType(response.settingType || 'showall');
        setIsReturn(!!response.isReturn);
        setIsMakePayment(!!response.isMakePayment);
        setIsChequeMakePayment(!!response.isChequeMakePayment);
        setTotalLinkHistoryAmt(response.totalLinkHistoryAmt || 0);
        setSelectedItemArray(items);
        setTermsId(response.dueTerms || 0);
        setDueOnDate(response.dueOnDate || moment().format("YYYY-MM-DD"));

        // items may be [] when the response is sparse; guard the
        // selectedData access so a missing tracking payload doesn't
        // crash the sold-out check.
        let isItemSoldOut = items.some((item) => item.trackingType == 'Normal' ? false : (Array.isArray(item.selectedData) && item.selectedData.some((data) => data.isSoldOut)));

          if(isItemSoldOut){
            alert('Some of these items have already been sold, so it cannot be update . In order to proceed, the specific sale transaction would need to be deleted first.');
          }
          setIsItemSoldOut(isItemSoldOut);
        getPrefixList(company_id, businessId, prefix);
        if (customer.party_id) {
          getPartyWiseItem(customer.party_id, company_id);
        }
        getBankListData(company_id);
        if(isConvert || isDuplicate){

        }else{
          setInvoiceNo(response.invoiceNo);
        }
        if (!isDuplicate && response.isReturn) {
          alert('This transaction cannot be updated because it has a partial or full return. To edit it, delete the return associated with the transaction.');
        } else{
          if(isConvert || isDuplicate){

          }else if(response.isMakePayment){
            alert('The payment for this purchase has been paid. Please delete the linked transaction to make changes.');
          } else if(response.isChequeMakePayment){
            alert('This transaction cannot be edited because cheque associated with the transaction is already closed. Re-open the cheque to edit this transaction.');
          }
        }
        
        } else {
          alert("Transaction details not found in system.");
          setTimeout(() => {
            window.location.href = global.webUrl + "business/purchase-invoice/";
            return;
          }, Math.floor(Math.random() * 5000) + 1);
        }
        
        setIsLoading(false);
      return responseJson;

    }else{
      getPrefixList(company_id, businessId);
      getBankListData(company_id);
    }
      
  }

  const getPartyListData = (_company_id) => {

    let _url_GetData = global.userPartyList + "?company_id=" + _company_id;
    setIsLoading(true);
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {

        } else {
          let _partyBal = 0;
          if (responseJson.response) {
            let _partyArray = responseJson.response;
            setPartyArray(_partyArray);
            _partyArray.map((party, index) => {
              if (party.party_id == partyId) {
                _partyBal = party.totalOutCome;
              }
            });
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  const getPartyWiseItem = (partyId, companyId) => {
    setIsLoading(true);
    const requestData = JSON.stringify({
      company_id: companyId,
      partyId: partyId,
      for_item_type: 'PURCHASE'
    });
    PostData(global.userItemSalePurPartyList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          setPartyItemArray([]);
        } else {
          if (responseJson.response) {
            let _itemsArray = responseJson.response;
            _itemsArray.map((field, index) => {
              _itemsArray[index].isFilter = false;
            });
            _itemsArray = _itemsArray.map((item) => {
              // itemBatchNo can be null/absent for Normal-tracked items —
              // an unguarded .filter would throw here, silently kill the
              // party-item load, and leave the Save button hidden.
              const _batchList = Array.isArray(item.itemBatchNo) ? item.itemBatchNo : [];
              return ({
                ...item,
                rate: item.purchase_price,
                quantity: 0,
                free_quantity: 0,
                trans_count: 0,
                discount_in_per: 0,
                discount_in_amount: 0,
                total_amount: 0,
                Additional_CESS: parseFloat(item.Additional_CESS) || 0,
                selectedData: [],
                itemBatchNo: _batchList.filter((data) => data.opening_stock > 0)
              })
            });
            setPartyItemArray(_itemsArray);

          }
        }
        setIsLoading(false);
      })
      .catch((error) => { setIsLoading(false); });
  }

  const callBackNewAddItem = (itemsArray) => {
    setPartyItemArray(itemsArray);
  }

  const getPaymentTerms = (companyId, businessId) => {
    let dummyData = [{ "id": -1, "terms_name": "Add Terms", "terms_days": 0, "terms_default_status": 0 },
    { "id": 0, "terms_name": "Custom", "terms_days": 0, "terms_default_status": 0 }];
    const requestDueDateData = JSON.stringify({
      businessId: businessId,
      company_id: companyId,
    });

    PostData(global.businessDueDatePaymentTermList, requestDueDateData, "POST")
      .then((result) => {
        let responseJson = result;
        
        if (responseJson.success == false) {
          setPaymentTermsData([...dummyData]);
        } else {
          let _mainResponse = responseJson.response;
          setPaymentTermsData([...dummyData, ..._mainResponse]);

          if (transactionType === 'ORDER' || !auth) {
            let terms = _mainResponse.find((data) => data.terms_default_status == 1);
            if (terms) {
              setTermsId(terms.id);
              setDueOnDate(moment(invoiceDate).add(terms.terms_days, 'days').format("YYYY-MM-DD"));
            }
          }
          
        }
      })
      .catch((error) => {

      });
  }
 
  const getPrefixList = (_company_id, _businessId, prefix) => {
    const dummyData = [
        { "isSelected": false, "prefix_id": -1, "prefix": "Add Prefix", "prefix_type": "PURCHASE" },
        { "isSelected": false, "prefix_id": 0, "prefix": "None", "prefix_type": "PURCHASE" }
    ];

    const requestData = JSON.stringify({
        company_id: _company_id,
        businessId: _businessId,
        type: "PURCHASE",
    });

    // Optionally set loading state here
    //setIsLoading(true);

    PostData(global.businessWebPrefixList, requestData, "POST")
        .then(async (result) => {
            let responseJson = result;

            if (!responseJson.success) {
                // Handle unsuccessful response
                setPrefixArray([...dummyData]);
                setPrefixId(0);
                setPrefixName('None');
            } else {
                if (responseJson.response) {
                    let _prefixArray = responseJson.response.filter(itemData => itemData.prefix != null);

                    if (prefix && prefix.id) {
                        const prefixData = _prefixArray.find(data => data.prefix_id === prefix.id);
                        if (prefixData) {
                            setPrefixId(prefixData.prefix_id);
                            setPrefixName(prefixData.prefix);
                        }
                    } else {
                        const _prefixSelData = _prefixArray.filter(item => item.isSelected);
                        let id = 0;
                        let name = 'None';

                        if (_prefixSelData.length === 0) {
                            // Set default selection for dummy data
                            const updatedDummyData = dummyData.map(data => ({
                                ...data,
                                isSelected: data.prefix_id === 0
                            }));
                            setPrefixArray([...updatedDummyData, ..._prefixArray]);
                        } else {
                            id = _prefixSelData[0].prefix_id;
                            name = _prefixSelData[0].prefix;
                            setPrefixArray([...dummyData, ..._prefixArray]);
                        }

                        setPrefixId(id);
                        setPrefixName(name);
                    }
                }
            }
        })
        .catch((error) => {
            console.error("Error fetching prefix list:", error);
            // Optionally show an error message to the user
        })
        .finally(() => {
            // Reset loading state
            //setIsLoading(false);
        });
  };
  const getStateListData = (countryCode) => {
    let _url_GetData =
      global.adminStateList + "?countryCode=" + countryCode;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
        } else {
          if (responseJson.response) {
            let _stateArray = responseJson.response;
            setStateArray(_stateArray);
          }
        }
      })
      .catch((error) => { });
  }
  const getBankListData = (company_id) => {
    let dummyData = [{ id: "-1", bank_name: "Add New Bank", paymentType: "" },
    { id: "-2", bank_name: "Cash", paymentType: "Cash" },
    { id: "-3", bank_name: "Cheque", paymentType: "Cheque" }]
    let _url_GetData = global.userBankDetailsList + "?company_id=" + company_id;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          setBankArray([...dummyData]);
        } else {
          if (responseJson.response) {
            let _bankDetailArray = responseJson.response;
            setBankArray([...dummyData, ..._bankDetailArray]);
          }
        }
      })
      .catch((error) => { });
  }

  const onToggleChange = () => {
    let reverseCharge = !isReverseCharge;
    if (reverseCharge) {
      let totalTax = totalTransTaxAmount + totalItemGstAmount + totalAdditionalCess;
      let payableAmount = totalAmount - totalTax;
      setReverseChargeTax(totalTax);
      setPayableAmount(roundToDecimalPlaces(payableAmount));
      let dueAmount = payableAmount - paidAmount;
      setDueAmount(roundToDecimalPlaces(dueAmount));
    } else {
      let payableAmount = totalAmount;
      setReverseChargeTax(0);
      setPayableAmount(roundToDecimalPlaces(payableAmount));
      let dueAmount = payableAmount - paidAmount;
      setDueAmount(roundToDecimalPlaces(dueAmount));
    }
    setIsReverseCharge(reverseCharge);
  }
  const getColorBal = () => {
    let _colorBal = "text-normal";
    if (partyRemainBalance < 0) {
      _colorBal = "text-danger";
    } else if (partyRemainBalance > 0) {
      _colorBal = "text-success";
    } else {
      _colorBal = "text-normal";
    }
    return _colorBal;
  }
  const onChangePartyName = (value) => {
    setSearchPartyName(value);
    setPartyId(0);
    setPartyName('');
  }
  const manageShowPartyFilter = () => {
    setPartyId(0);
    setPartyName('');
    setShowPartyViewList(true);
  }


  const viewPartyList = () => {
    let _colorVal = '';
    let data = partyArray.filter((data) => data.party_name.toLowerCase().includes(searchPartyName.toLowerCase())).map((party, i) => {
      let _balance = party.totalOutCome;
      if (_balance < 0) {
        _colorVal = "red";
      } else if (_balance == 0 || _balance == "0") {
        _colorVal = "black";
      } else {
        _colorVal = "green";
      }
      return (
        <li
          key={i}
          className="iti__party iti__standard"
          id="iti-item-in"
          onClick={() => selectPartiess(party)}
        >
          <span className="iti__party-name">{party.party_name}</span>
          <span className="iti__party-balance" style={{ color: _colorVal }}>
            {numberFormat(Math.abs(_balance))}
          </span>
        </li>
      );
    });
    return data;
  }
  const selectPartiess = (party) => {
    setSearchPartyName('');
    setPartyId(party.party_id);
    setPartyName(party.party_name);
    setPartyRemainBalance(party.totalOutCome);
    setPartyContactNo(party.party_contact_no);
    setBillingName(party.billing_name);
    setBillingAddress(party.party_billing_address);
    setStateName(party.countryState);
    setShowPartyViewList(false);
    getPartyWiseItem(party.party_id, companyId);
  }
  const handleCallBackPoDate = (date) => {
    setPoDate(moment(date).format("YYYY-MM-DD"));
  };
  const viewPoDate = () => {
    const slectedDate = moment(poDate).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        disabled={isConvert || isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackPoDate(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const selectPaymentTerms = (e) => {
    let value = e.target.value;
    if (value == -1) {
      setIsDialogOpen_AddTerms(true);
    } else {
      let patmentData = paymentTermsData.filter((data) => data.id == value)[0];
      let _invDate = moment(invoiceDate).format("YYYY-MM-DD");
      let newDueDate = moment(_invDate).add(patmentData.terms_days, "days").format("YYYY-MM-DD");
      setDueOnDate(newDueDate);
      setTermsId(value);
    }
  }

  const selectPrefix = (e) => {
    let value = e.target.value;
    if (value == -1) {
      setIsDialogOpen_AddPrefix(true);
    } else {
      let prefixData = prefixArray.filter((data) => data.prefix_id == value)[0];
      setPrefixId(prefixData.prefix_id);
      setPrefixName(prefixData.prefix);
    }
  }
  const handleCallBackDueTermsDate = (date) => {
    setDueOnDate(moment(date).format("YYYY-MM-DD"));
    setTermsId(0);
  };
  const viewDueOnDate = () => {
    const slectedDate = moment(dueOnDate).toDate();
    return (
      <DatePicker
        minDate={new Date(invoiceDate)}
        selected={slectedDate}
        disabled={isConvert || isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackDueTermsDate(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const handleCallBackInvoiceDate = (date) => {
    date = moment(date).format("YYYY-MM-DD")
    setInvoiceDate(date);
    if (termsId > 0) {
      let patmentData = paymentTermsData.filter((data) => data.id == termsId)[0];
      let newDueDate = moment(date).add(patmentData.terms_days, "days").format("YYYY-MM-DD");
      setDueOnDate(newDueDate);
    }
  };
  const viewInvoiceDate = () => {
    const slectedDate = moment(invoiceDate).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        disabled={isConvert || isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackInvoiceDate(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const handleCallBackAdditionalValue4Date = (date) => {
    setAdditionalValue4(moment(date).format("YYYY-MM-DD"));
  };
  const viewAdditionalDate = () => {
    const slectedDate = moment(additionalValue4).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        disabled={isConvert || isDuplicate}
        className="form-control search-box"
        onChange={date => handleCallBackAdditionalValue4Date(date)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  }
  const onMouseLeaveHandlerTime = () => {
    setIsDialogOpen_Time(false)
  }
  const onMouseLeaveHandler = () => {

  }
  const manageShowTimeFilter = () => {

  }
  const generateTimeSlots = (interval = 1) => {
    const slots = [];
    const start = new Date(); // Start from current time
    start.setSeconds(0, 0); // Round down to the nearest hour

    for (let i = 0; i < 24 * 60 / interval; i++) {
      start.setMinutes(start.getMinutes() + interval);
      //slots.push(formatTime(new Date(start)));
      slots.push(moment(start).format("hh:mm A"));
    }

    return slots;
  };
  const availableTimeSlots = generateTimeSlots();
  const getTimeSlotList = () => {
    return availableTimeSlots.map((time, index) => (
      <div
        key={index}
        className="dropdown-item"
        onClick={() => {
          setIsDialogOpen_Time(false);
          setInvoiceTime(time);
        }}
      >
        {time}
      </div>
    ))
  }

  const selectBank = (e) => {
    let value = e.target.value;
    if (value == -1) {
      setIsDialogAddNewBank(true);
    } else {
      let bankData = bankArray.filter((data) => data.id == value)[0];
      setBankId(value);
      setBankName(bankData.bank_name ? bankData.bank_name : bankData.display_name);
      setPaymentType(bankData.paymentType);
    }
  }
  const onChangeFileUploadHandler = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      const validImageTypes = ['image/jpeg', 'image/png'];
        if (validImageTypes.includes(file.type)) {
          setDescImage(file);
          setImagePreviewUrl(reader.result);
        }else{
          e.target.value = '';
          alert('Please select a valid image file (JPEG, PNG, GIF).');
          return
        }
    };
    reader.readAsDataURL(file);
  }
  const previewImagesListing = () => {
    let dataList = [];
    let _imageDetails = imagePreviewUrl;
    if (_imageDetails != "") {
      dataList.push(
        <>
        <img
          style={{ width: "50px", height: '50px' }}
          className="preview"
          src={_imageDetails}
          alt={"image-"}
          key="13213"
        />
        <button
        style={{marginLeft: 10}}

            className="btn btn-info"
            onClick={() => {
              setIsDialogPreviewImage(true);
            }}
        >
            <i className="fa fa-eye" title="Preview"></i>
        </button>
        <button
        style={{marginLeft: 10}}
            className="btn btn-info"
            onClick={() => {
              refDescImage.current.value = '';
              setDescImage('');
              setImagePreviewUrl('');
            }}
        >
            <i className="fa fa-trash" title="Delete"></i>
        </button>
        </>
        
      );
    }
    return dataList;
  }
  const roundToDecimalPlaces = (value) => {
    value = parseFloat(value);
    value = isNaN(value) ? 0 : parseFloat(value.toFixed(2));
    return value;
  };

  const onCallbackAddTerms = (data) => {
    // Close the dialog for adding new payment terms
    setIsDialogOpen_AddTerms(false);

    // Validate the input data if necessary
    if (!data) {
        console.error("Invalid data for payment terms.");
        return; // Exit if the data is invalid
    }

    // Optionally, set a loading state here
    setIsLoading(true);

    // Fetch the updated list of payment terms
    getPaymentTerms(companyId, businessId)
        .then(() => {
            // Optionally, show a success message here
            console.log("Payment terms updated successfully.");
        })
        .catch((error) => {
            console.error("Error fetching payment terms:", error);
            // Optionally, show an error message here
        })
        .finally(() => {
            // Reset loading state
            setIsLoading(false);
        });
  };
  
  const onCallbackAddPrefix = (id, name) => {
    // Close the dialog for adding a new prefix
    setIsDialogOpen_AddPrefix(false);

    // Validate the input values
    if (!id || !name) {
        console.error("Invalid prefix ID or name.");
        return; // Exit if the values are invalid
    }

    // Update the state with the new prefix ID and name
    setPrefixId(id);
    setPrefixName(name);

    // Optionally, set a loading state here
    //setIsLoading(true);

    // Fetch the updated list of prefixes
    getPrefixList(companyId, businessId);
  };

  const onChangeDiscountPercentage = (value) => {
    const discountPercentage = Number(value); // Ensure value is a number

    // Validate discount percentage
    if (discountPercentage > 100) {
        console.error('Discount percentage cannot be greater than 100.');
        return; // Exit if discount is invalid
    }

    // Update discount percentage state
    setTotalTransDiscountPer(discountPercentage);

    // Calculate discount amount
    const discountAmount = roundToDecimalPlaces((discountPercentage / 100) * subTotalAmount);
    setTotalTransDiscountAmount(discountAmount);

    // Calculate new subtotal
    const newSubTotalAmount = subTotalAmount - discountAmount;

    // Find the tax rate
    const taxRate = taxRateArray.find((data) => data.id === transactionWiseTaxId);
    if (!taxRate) {
        console.error("Tax rate not found for ID:", transactionWiseTaxId);
        return; // Exit if tax rate is not found
    }

    // Calculate tax amount
    const taxAmount = roundToDecimalPlaces((taxRate.ratio / 100) * newSubTotalAmount);
    setTotalTransTaxAmount(taxAmount);

    // Calculate total amount
    const totalAmount = roundToDecimalPlaces(newSubTotalAmount + taxAmount + transAdditionalCharge1 + transAdditionalCharge2 + transAdditionalCharge3);
    setTotalAmount(totalAmount);

    // Calculate reverse charge tax if applicable
    const reverseChargeTax = isReverseCharge ? roundToDecimalPlaces(totalItemGstAmount + taxAmount + totalAdditionalCess) : 0;
    setReverseChargeTax(reverseChargeTax);

    // Calculate payable and due amounts
    const payableAmount = roundToDecimalPlaces(totalAmount - reverseChargeTax);
    setPayableAmount(payableAmount);
    setDueAmount(roundToDecimalPlaces(payableAmount - paidAmount));
  };
  const onChangeDiscountAmount = (value) => {
    const discountAmount = Number(value); // Ensure value is a number

    // Validate discount amount
    if (discountAmount > subTotalAmount) {
        console.error('Discount amount cannot be greater than total amount.');
        return; // Exit if discount is invalid
    }

    // Update discount amount state
    setTotalTransDiscountAmount(discountAmount);

    // Calculate discount percentage
    const discountPercentage = roundToDecimalPlaces((discountAmount / subTotalAmount) * 100);
    setTotalTransDiscountPer(discountPercentage);

    // Calculate new subtotal
    const newSubTotalAmount = subTotalAmount - discountAmount;

    // Find the tax rate
    const taxRate = taxRateArray.find((data) => data.id === transactionWiseTaxId);
    if (!taxRate) {
        console.error("Tax rate not found for ID:", transactionWiseTaxId);
        return; // Exit if tax rate is not found
    }

    // Calculate tax amount
    const taxAmount = roundToDecimalPlaces((taxRate.ratio / 100) * newSubTotalAmount);
    setTotalTransTaxAmount(taxAmount);

    // Calculate total amount
    const totalAmount = roundToDecimalPlaces(newSubTotalAmount + taxAmount + transAdditionalCharge1 + transAdditionalCharge2 + transAdditionalCharge3);
    setTotalAmount(totalAmount);

    // Calculate reverse charge tax if applicable
    const reverseChargeTax = isReverseCharge ? roundToDecimalPlaces(totalItemGstAmount + taxAmount + totalAdditionalCess) : 0;
    setReverseChargeTax(reverseChargeTax);

    // Calculate payable and due amounts
    const payableAmount = roundToDecimalPlaces(totalAmount - reverseChargeTax);
    setPayableAmount(payableAmount);
    setDueAmount(roundToDecimalPlaces(payableAmount - paidAmount));
  };
  const onChangeTaxRate = (value) => {
    value = Number(value); // Ensure value is a number
    setTransactionWiseTaxId(value);

    // Calculate subtotal after discount
    let _subTotalAmount = subTotalAmount - totalTransDiscountAmount;

    // Find the tax rate
    let _taxRate = taxRateArray.find((data) => data.id === value);
    if (!_taxRate) {
        console.error("Tax rate not found for ID:", value);
        return; // Exit if tax rate is not found
    }

    // Calculate tax amount
    let _taxAmount = roundToDecimalPlaces((_taxRate.ratio / 100) * _subTotalAmount);
    setTotalTransTaxRatio(_taxRate.ratio);
    setTotalTransTaxAmount(_taxAmount);

    // Calculate total amount
    let _totalAmount = roundToDecimalPlaces(_subTotalAmount + _taxAmount + transAdditionalCharge1 + transAdditionalCharge2 + transAdditionalCharge3);
    setTotalAmount(_totalAmount);

    // Calculate reverse charge tax if applicable
    let reverseChargeTax = isReverseCharge ? roundToDecimalPlaces(totalItemGstAmount + _taxAmount + totalAdditionalCess) : 0;
    setReverseChargeTax(reverseChargeTax);

    // Calculate payable and due amounts
    let payableAmount = roundToDecimalPlaces(_totalAmount - reverseChargeTax);
    setPayableAmount(payableAmount);
    setDueAmount(roundToDecimalPlaces(payableAmount - paidAmount));
  };
  const onChangeAdditionalCharge1 = (value) => {
    value = value * 1;
    setTransAdditionalCharge1(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = (_totalAmount - totalTransDiscountAmount) + totalTransTaxAmount + value + transAdditionalCharge2 + transAdditionalCharge3;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));

    let payableAmount = _totalAmount > reverseChargeTax ? _totalAmount - reverseChargeTax : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    let dueAmount = payableAmount - paidAmount;
    setDueAmount(roundToDecimalPlaces(dueAmount));
    
  }
  const onChangeAdditionalCharge2 = (value) => {
    value = value * 1;
    setTransAdditionalCharge2(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = (_totalAmount - totalTransDiscountAmount) + totalTransTaxAmount + transAdditionalCharge1 + value + transAdditionalCharge3;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));
    
    let payableAmount = _totalAmount > reverseChargeTax ? _totalAmount - reverseChargeTax : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    let dueAmount = payableAmount - paidAmount;
    setDueAmount(roundToDecimalPlaces(dueAmount));
  }
  const onChangeAdditionalCharge3 = (value) => {
    value = value * 1;
    setTransAdditionalCharge3(value);
    let _totalAmount = subTotalAmount;
    _totalAmount = (_totalAmount - totalTransDiscountAmount) + totalTransTaxAmount + transAdditionalCharge1 + transAdditionalCharge2 + value;
    setTotalAmount(roundToDecimalPlaces(_totalAmount));
    
    let payableAmount = _totalAmount > reverseChargeTax ? _totalAmount - reverseChargeTax : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    let dueAmount = payableAmount - paidAmount;
    setDueAmount(roundToDecimalPlaces(dueAmount));
  }
  const onChangePaidAmount = (value) => {
    let newValue = value;
    newValue = newValue.replace(/[^0-9.-]/g, '');

    if ((newValue.match(/\./g) || []).length > 1) {
      newValue = newValue.slice(0, -1);
    }
    if(newValue > payableAmount){
      return;
    }
    
    setPaidAmount(newValue);

    let _totalAmount = payableAmount - newValue;
    setDueAmount(roundToDecimalPlaces(_totalAmount));
  }
  const callBack = async (data, _totalAmount, totalQuantity, itemSubTotalAmount, totalItemGstAmount, totalAdditionalCess) => {
    
    setSubTotalAmount(_totalAmount);
    setItemSubTotalAmount(itemSubTotalAmount);
    setTotalItemGstAmount(totalItemGstAmount);
    setTotalQuantity(totalQuantity);
    setSelectedItemArray(data);
    let _discountAmount = (totalTransDiscountPer / 100) * _totalAmount;
    _discountAmount = roundToDecimalPlaces(_discountAmount);
    setTotalTransDiscountAmount(_discountAmount);
    _totalAmount = _totalAmount - _discountAmount;
    let _taxRate = taxRateArray.filter((data) => data.id == transactionWiseTaxId)[0];
    let _taxAmount = (_taxRate.ratio / 100) * _totalAmount;
    _taxAmount = roundToDecimalPlaces(_taxAmount);
    setTotalTransTaxRatio(_taxRate.ratio);
    setTotalTransTaxAmount(_taxAmount);
    let totalAmount = _totalAmount + (_taxAmount + transAdditionalCharge1 + transAdditionalCharge2 + transAdditionalCharge3);
    setTotalAmount(roundToDecimalPlaces(totalAmount));
    
    let reverseChargeTax = isReverseCharge ? (totalItemGstAmount + _taxAmount + totalAdditionalCess) : 0;
    setReverseChargeTax(reverseChargeTax);
    setTotalAdditionalCess(totalAdditionalCess);
    let payableAmount = totalAmount > 0 ? (totalAmount - reverseChargeTax) : 0;
    setPayableAmount(roundToDecimalPlaces(payableAmount));

    let _dueAmount = payableAmount - paidAmount;
    setDueAmount(roundToDecimalPlaces(_dueAmount));
    //setDueAmount(isMakePayment ? dueAmount : _dueAmount);

  }
  

  const clickToAddPurchase = () => {
    if (isReturn && !isDuplicate) {
      alert('This transaction cannot be updated because it has a partial or full return. To edit it, delete the return associated with the transaction.');
    } else if (selectedItemArray.length <= 0) {
      alert('Please select at least one item.');
    } else if (selectedItemArray.filter((data) => parseInt(data.rate) == 0).length > 0) {
      alert('Price/Unit must be greater than 0.');
    } else if (dueAmount < 0) {
      alert('Due amount cannot be less than 0.');
    } else if (bankId == 0) {
      alert('Please select payment type like (Cash, Cheque or any bank.)');
    }  else if(isItemSoldOut){
      alert('Some of these items have already been sold, so it cannot be update . In order to proceed, the specific sale transaction would need to be deleted first.');
    } else {
      if(isConvert || isDuplicate){

      } else if (isMakePayment) {
        alert('The payment for this purchase has been paid. Please delete the linked transaction to make changes.');
        return;
      } else if(isChequeMakePayment){
        alert('This transaction cannot be edited because cheque associated with the transaction is already closed. Re-open the cheque to edit this transaction.');
        return;
      }
      setIsLoading(true);
      let customer = {
        party_id: partyId,
        party_name: partyName,
        party_contact_no: partyContactNo,
        party_opening_balance: partyRemainBalance,
        billing_name: billingName,
      };
      let prefix = {
        name: prefixName,
        id: prefixId,
        isActive: "1",
      };
      let totalSummary = {
        subtotal: subTotalAmount,
        gstRatio: totalTransTaxRatio,
        gstAmount: totalTransTaxAmount,
        totalQty: totalQuantity,
        totalDiscount: totalTransDiscountAmount,
        totalAmount: totalAmount,
        receivedAmount: 0,
        paidAmount: paidAmount ? paidAmount : 0,
        dueAmount: dueAmount,
        reverseChargeTax: reverseChargeTax,
        payableAmount: payableAmount,
        reverseChargeStatus: isReverseCharge,
      };
      let transactionWiseAmount = {
        transactionWiseTaxId: transactionWiseTaxId,
        totalTransTaxAmount: totalTransTaxAmount,
        totalTransDiscountPer: totalTransDiscountPer,
        totalTransDiscountAmount: totalTransDiscountAmount,
      };
      let transactionAdditionalCharge = {
        TransAdditionalCharge1: transAdditionalCharge1,
        TransAdditionalCharge2: transAdditionalCharge2,
        TransAdditionalCharge3: transAdditionalCharge3,
      };
      let transacTransportationDetails = {
        TransportDetailField1: transportDetailField1,
        TransportDetailField2: transportDetailField2,
        TransportDetailField3: transportDetailField3,
        TransportDetailField4: transportDetailField4,
        TransportDetailField5: transportDetailField5,
        TransportDetailField6: transportDetailField6,
      };
      let purchaseData = new FormData();
      purchaseData.append("transaction_id", transactionId);
      purchaseData.append("business_id", businessId);
      purchaseData.append("user_id", signingId);
      purchaseData.append("company_id", companyId);
      purchaseData.append("customer", JSON.stringify(customer));
      purchaseData.append("billing_address", billingAddress);
      purchaseData.append("poNumber", poNumber);
      purchaseData.append("poDate", poDate);
      purchaseData.append("dueOnDate", dueOnDate);
      purchaseData.append("dueTerms", termsId);
      purchaseData.append("E_Way_Bill_No", EWayBillNo);
      purchaseData.append("prefix", JSON.stringify(prefix));
      purchaseData.append("invoiceNo", invoiceNo);
      purchaseData.append("invoiceDate", invoiceDate);
      purchaseData.append("invoiceTime", invoiceTime);
      purchaseData.append("selectedCountry", countryName);
      purchaseData.append("countryState", stateName);
      purchaseData.append("items", JSON.stringify(selectedItemArray));
      purchaseData.append("totalSummary", JSON.stringify(totalSummary));
      purchaseData.append("transactionWiseAmount", JSON.stringify(transactionWiseAmount));
      purchaseData.append("transactionAdditionalCharge", JSON.stringify(transactionAdditionalCharge));
      purchaseData.append("additional_value_1", additionalValue1);
      purchaseData.append("additional_value_2", additionalValue2);
      purchaseData.append("additional_value_3", additionalValue3);
      purchaseData.append("additional_value_date", additionalValue4);
      purchaseData.append("bankId", bankId);
      purchaseData.append("bankName", bankName);
      purchaseData.append("paymentType", paymentType);
      purchaseData.append("paymentRefNo", paymentRefNo);
      purchaseData.append("description", description);
      purchaseData.append("descImage", descImage);
      purchaseData.append("settingType", printType);
      purchaseData.append("transactionTransportationDetails", JSON.stringify(transacTransportationDetails));

      if (isEditMode) {
        purchaseData.append("isMakePayment", isMakePayment);
        purchaseData.append("totalLinkHistoryAmt", totalLinkHistoryAmt);
      }
      if (isConvert || isDuplicate) {
        purchaseData.append("sendUrlType", transactionType);
      }

      const formObject = {};
      purchaseData.forEach((value, key) => {
        if (key == 'customer' || key == 'prefix' || key == 'items' || key == 'totalSummary' || key == 'transactionWiseAmount' || key == 'transactionAdditionalCharge' | key == 'transactionTransportationDetails') {
          value = JSON.parse(value);
        }
        formObject[key] = value;
      });
      console.log('formObject', JSON.stringify(formObject));
      //setIsLoading(false); return;
      let url = (isConvert || isDuplicate) ? global.createPurchaseDuplicate : (isEditMode ? global.editPurchaseTransaction : global.createPurchaseTransaction);
      console.log('url', url);
      fetch(url, {
        method: "POST",
        body: purchaseData,
      })
        .then((response) => response.json())
        .then((res) => {
          console.log('res', JSON.stringify(res));
          setIsLoading(false);
          if (res.success == true) {
            setTransactionId(res.transaction_Id);
            setShowSuccessDialog(true);
          } else {
            console.log('res.message', JSON.stringify(res.message));
            alert(res.message);
          }
          setMessage(res.message);
        })
        .catch((error) => {
          console.log('error', error);
          setIsLoading(false);
        });

    }
  }

  return (
    <div className="">
      <div className="content">
        <div className="content-header">
          <div className="header-section">
            {/* <h2 className="content-heading">Manage Business</h2> */}
            <h1 className="content-heading">
              <i className="gi gi-direction"></i>Add / Edit Purchase Bill
              <br />
            </h1>
          </div>
        </div>
        <nav className="breadcrumb push">
          <Link className="breadcrumb-item" to={"/business/dashboard/"}>
            Dashboard
          </Link>
          <Link className="breadcrumb-item" to={"/business/purchase-invoice/"}>
            Manage Purchase Bill List
          </Link>
          <span className="breadcrumb-item active">
            Add / Edit Purchase Bill
          </span>
          <Link
            className="breadcrumb-item"
            to={"/business/add-purchase/"}
            target="_blank"
          >
            <i className="fa fa-plus"> (Add More)</i>
          </Link>
        </nav>
        {isReadOnly && (
          <div className="alert alert-info d-flex align-items-center mb-3" role="alert">
            <i className="fa fa-info-circle mr-10"></i>
            <div>
              <strong>View Only Mode:</strong> {isDuplicateCopyView
                ? 'This is a duplicate purchase and cannot be edited. You can view the details but cannot make changes.'
                : 'This purchase has a return associated with it and cannot be edited. You can view the details but cannot make changes.'}
            </div>
          </div>
        )}
        <fieldset style={isReadOnly ? {opacity: 0.9} : {}}>
        <div className="block">
          <div className="row">
            <div className="col-md-6">
              <div className="block block-transparent">
                <div className="block-content" id="formSideLeft">
                  <div className="form-group row">
                    <div className="col-6">
                      <div
                        className="form-material open"
                        onMouseLeave={() => onMouseLeaveHandler()}
                      >
                        <input
                          disabled={isEditMode || selectedItemArray.length > 0}
                          readOnly={selectedItemArray.length > 0}
                          type="text"
                          className="form-control search-box"
                          onChange={(e) => onChangePartyName(e.target.value)}
                          onClick={() => manageShowPartyFilter()}
                          onBlur={() => partyName && setShowPartyViewList(false)}
                          placeholder="Search Party Name Here..."
                          autoComplete="off"
                          name="party_name"
                          id="party_name"
                          value={partyName ? partyName : searchPartyName}
                        />
                        <label htmlFor="login-username">
                          Party Name <span className="text-danger">*</span>
                        </label>
                        {
                          showPartyViewList &&
                          <ul
                            className={" iti__party-list iti__party-list--dropup"
                            }
                            id="country-listbox"
                            aria-expanded="false"
                            role="listbox"
                            aria-activedescendant="iti-item-ad"
                          >
                            <li
                              key={-1}
                              id="iti-item-in"
                              className="iti__party iti__standard"
                              style={{fontWeight: 'bold'}}
                              onClick={() => {setIsDialogAddNewParty(true)}}
                            >
                              <span className="iti__party-name">{'Add New Party'}</span>
                            </li>
                            {viewPartyList()}
                          </ul>
                        }
                        <div className={getColorBal() + ' '}>
                          {partyName != ""
                            ? "Bal : " +
                            numberFormat(
                              Math.abs(partyRemainBalance)
                            )
                            : ""}
                        </div>
                      </div>
                    </div>
                    {
                      businessSetting.ReverseCharge == 1 &&
                      <div
                      className={"col-6"}
                    >
                      <div>
                        <ToggleSwitch
                          txtRight="Reverse Charge"
                          small
                          id="newsletter"
                          checked={isReverseCharge}
                          disabled={isDuplicate}
                          onChange={() => onToggleChange()}
                        />
                      </div>
                    </div>
                    }
                    
                    <div className="col-6">
                      <div className="form-material open">
                        <input
                          type="text"
                          className="form-control search-box"
                          placeholder="Phone Number"
                          autoComplete="off"
                          value={partyContactNo}
                          disabled={isConvert || isDuplicate}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[0-9]*$/.test(value)) {
                              setPartyContactNo(value);
                            }
                          }}
                          maxLength="13"
                        />
                        <label htmlFor="login-username">Phone Number</label>

                      </div>
                    </div>
                    {businessSetting.Tran_BillingNameParty == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="Billing Name Here..."
                            autoComplete="off"
                            value={billingName}
                            disabled={isConvert || isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBillingName(value);
                            }}
                          />
                          <label htmlFor="login-username">Billing Name</label>
                        </div>
                      </div>
                    )}
                    {businessSetting.Tran_BillingNameParty == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="Billing Address Here..."
                            autoComplete="off"
                            value={billingAddress}
                            disabled={isConvert || isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBillingAddress(value);
                            }}
                          />
                          <label htmlFor="login-username">Billing Address</label>
                        </div>
                      </div>
                    )}
                    {businessSetting.Tran_CustomerPO == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          {viewPoDate()}
                          <label htmlFor="login-username">PO Date</label>
                        </div>
                      </div>
                    )}
                    {businessSetting.Tran_CustomerPO == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="PO Number"
                            autoComplete="off"
                            maxLength="20"
                            onKeyPress={(e) => handleKeyPress(e)}
                            value={poNumber}
                            disabled={isConvert || isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[0-9]*$/.test(value)) {
                                setPoNumber(value);
                              }
                            }}
                          />
                          <label htmlFor="login-username">PO Number</label>
                        </div>
                      </div>
                    )}

                    {businessSetting.EWayBillNo == 1 && (
                      <div className="col-6">
                        <div className="form-material open">
                          <input
                            type="text"
                            className="form-control search-box"
                            placeholder="E Way Bill No"
                            autoComplete="off"
                            value={EWayBillNo}
                            disabled={isConvert || isDuplicate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEWayBillNo(value);
                            }}
                          />
                          <label htmlFor="login-username">
                            E Way Bill No
                          </label>
                        </div>
                      </div>
                    )}
                    {businessSetting.DueDatesPaymentTerms == 1 &&
                      <div className="col-6">
                          <div className="form-material open">

                            <select
                              className="form-control "
                              required="required"
                              onChange={(e) => selectPaymentTerms(e)}
                              value={termsId}
                              disabled={isConvert || isDuplicate}
                            >
                              {paymentTermsData.map(
                                (item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.terms_name}
                                    </option>
                                  );
                                }
                              )}
                            </select>


                            <label htmlFor="login-username">Pmt. Terms</label>
                          </div>
                        </div>
                      }

                    {businessSetting.DueDatesPaymentTerms == 1 &&
                      <div className="col-6">
                          {businessSetting.DueDatesPaymentTerms == 1 &&
                            <div className="form-material open">
                              {viewDueOnDate()}
                              <label htmlFor="login-username">Due On</label>
                            </div>
                          }
                        </div>
                      }
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="block block-transparent">
                <div className="block-content">
                  <div className="" id="formSideRight">
                    {businessSetting.InvoiceBillNo == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          Bill No. <span className="text-danger">*</span>
                        </label>
                        <div
                          className="col-lg-3 form-material"
                          id="paddingOff"
                        >

                          <select
                            className="form-control "
                            required="required"
                            onChange={(e) => selectPrefix(e)}
                            value={prefixId}
                            disabled={isConvert || isDuplicate}
                          >

                            {prefixArray.map(
                              (prefixData, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={prefixData.prefix_id}
                                  >
                                    {prefixData.prefix}
                                  </option>
                                );
                              }
                            )}
                          </select>
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div
                          className="col-lg-4 form-material"
                          id="paddingOff"
                        >
                          <input
                            type="text"
                            className="form-control"
                            required="required"
                            maxLength="20"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[0-9]*$/.test(value)) {
                                setInvoiceNo(value);
                              }
                            }}
                            placeholder="Enter a Invoice No."
                            autoComplete="off"
                            value={invoiceNo}
                          />

                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <label
                        style={{ textAlign: "right" }}
                        className="col-lg-4 col-form-label"
                        htmlFor="val-username"
                      >
                        Bill Date <span className="text-danger">*</span>
                      </label>

                      <div className="col-lg-8 form-material" id="paddingOff">
                        {viewInvoiceDate()}
                      </div>
                    </div>
                    {businessSetting.Tran_AddTime == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          Time
                        </label>
                        <div
                          className="col-lg-8 form-material"
                          id="paddingOff"
                          onMouseLeave={() => onMouseLeaveHandlerTime()}
                        >
                          <input
                            readOnly="readOnly"
                            type="text"
                            className="form-control search-box"
                            onClick={() => setIsDialogOpen_Time(true)}
                            placeholder="Please Select Time"
                            autoComplete="off"
                            name="invoiceTime"
                            id="invoiceTime"
                            value={invoiceTime}
                            disabled={isConvert || isDuplicate}
                          />
                          {
                            isDialogOpen_Time &&
                            <ul
                              className={" iti__party-list iti__party-list--dropup"}
                              id="country-listbox"
                              aria-expanded="false"
                              role="listbox"
                              aria-activedescendant="iti-item-ad"
                            >
                              {getTimeSlotList()}
                            </ul>
                          }
                        </div>
                      </div>
                    )}
                    {businessSetting.SateOfSupply == 1 && (
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="val-username"
                        >
                          State of Supply
                        </label>
                        <div
                          className="col-lg-8 form-material"
                          id="paddingOff"
                        >
                          <select
                            className="form-control "
                            id="countryState"
                            name="countryState"
                            value={stateName}
                            disabled={isConvert || isDuplicate}
                            onChange={(e) => setStateName(e.target.value)}
                          >
                            <option value=""> None</option>
                            {stateArray.map((item, index) => {
                              return (
                                <option
                                  key={index}
                                  value={item.name}
                                >
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    )}

                    <div className="form-material open"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* table page */}
          {
            partyId > 0 &&
            <PurchaseAddItemTable
              isConvert={isConvert || isDuplicate}
              isEditMode={isEditMode}
              isPurchaseType={true}
              partyItemArray={partyItemArray}
              selectedItemArray={selectedItemArray}
              callBackNewAddItem={(items) => callBackNewAddItem(items)}
              callBack={(data, totalAmount, totalQuantity, itemSubTotalAmount, totalItemGstAmount, totalAdditionalCess) => { callBack(data, totalAmount, totalQuantity, itemSubTotalAmount, totalItemGstAmount, totalAdditionalCess) }}
            />
          }
          {/* table page */}
          {
            // Convert / Duplicate / Edit flows pre-populate selectedItemArray
            // from the source transaction, but partyItemArray can legitimately
            // be empty (party-items API returns success:false when the company
            // has no items in vs_user_item_data). Gating the bottom section —
            // bank, description, totals, Save button — on partyItemArray
            // hides the whole form and reads as a blank page.
            selectedItemArray.length > 0 &&
            <div className="row">
              <div className="col-md-6">
                <div className="block block-transparent">
                  <div className="block-content" id="formSideLeft">
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="form-material open" id="paddingOff">
                          <select
                            className="col-8 form-control"
                            value={bankId}
                            onChange={(e) => selectBank(e)}
                            disabled={isConvert || isDuplicate}
                          >
                            {
                              bankArray.map((bankD, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={bankD.id}
                                  >
                                    {bankD.bank_name ? bankD.bank_name : bankD.display_name}
                                  </option>
                                )
                              })
                            }
                          </select>
                        </div>
                        {paymentType != "Cash" && (
                          <div className="form-material open">
                            <div
                              className="col-8 form-material"
                              id="paddingOff"
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={paymentRefNo}
                                required="required"
                                onChange={(e) => setPaymentRefNo(e.target.value)}
                                placeholder="Enter Reference No.."
                                autoComplete="off"
                                maxLength={30}
                                disabled={isConvert || isDuplicate}
                              />
                            </div>
                          </div>
                        )}
                        <div className="form-material open">
                          <div className="col-12 form-material" id="paddingOff">
                            <input
                              type="text"
                              className="form-control"
                              required="required"
                              onChange={(e) => setDescription(e.target.value)}
                              placeholder="Enter a description"
                              autoComplete="off"
                              value={description}
                              disabled={isConvert || isDuplicate}
                            />
                          </div>
                        </div>
                        <div className="form-material open">
                          <div className="col-8 form-material" id="paddingOff">
                            <input
                            ref={refDescImage}
                              type="file"
                              accept="image/*"
                              style={{ width: "60%", display: "inline-block" }}
                              autoComplete="false"
                              className="form-control"
                              id="descImage"
                              name="descImage"
                                disabled={isConvert || isDuplicate}
                              onChange={(e) => onChangeFileUploadHandler(e)}
                            />
                            {previewImagesListing()}
                            
                          </div>
                        </div>

                        {businessSetting.PrintOriginalDuplicate == 1 && (
                          <div className="form-material open">
                            <label
                              style={{ textAlign: "right", position: "static" }}
                              className="col-form-label"
                              htmlFor="totalAmount"
                            >
                              Original / Duplicate Setting
                            </label>
                            <div
                              className="col-8 form-material"
                              id="paddingOff"
                            >
                              <select
                                className="col-8 form-control"
                                onChange={(e) => setPrintType(e.target.value)}
                                value={printType}
                                disabled={isConvert || isDuplicate}
                              >
                                {printTypeList.map(({ value, label }, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={value}
                                    >
                                      {label}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="block block-transparent">
                  <div className="block-content">
                    <div id="taxDisData">
                      <div className="col-md-12" id="formSideRight">
                        <div className="row">
                          <label
                            style={{
                              textAlign: "right",
                              margin: "25px 0 0 0",
                            }}
                            className="col-lg-4 col-form-label"
                          >
                            Sub Total Amount
                          </label>
                          <div
                            className="col-lg-4 form-material"
                            style={{
                              padding: "0 !important",
                              margin: "0 !important",
                            }}
                          >
                            <input
                              type="text"
                              className={"form-control"}
                              autoComplete="off"
                              value={itemSubTotalAmount}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      {businessSetting.TransactionWiseDiscount == 1 && (
                        <div className="col-md-12" id="formSideRight">
                          <div className="form-group row">
                            <label
                              style={{
                                textAlign: "right",
                                margin: "25px 0 0 0",
                              }}
                              className="col-lg-4 col-form-label"
                            >
                              Discount %
                            </label>
                            <div
                              className="col-lg-4 form-material"
                              id=""
                              style={{
                                padding: "0 !important",
                                margin: "0 !important",
                              }}
                            >
                              <input
                                type="text"
                                id="totalTransDiscountPer"
                                name="totalTransDiscountPer"
                                onChange={(e) => onChangeDiscountPercentage(e.target.value)}
                                placeholder="In %"
                                className={"form-control"}
                                onKeyPress={(e) => handleKeyPress(e)}
                                autoComplete="off"
                                value={totalTransDiscountPer}
                                disabled={isConvert || isDuplicate}
                              />
                            </div>
                            <div
                              className="col-lg-4 form-material"
                              id=""
                              style={{
                                padding: "0 !important",
                                margin: "0 !important",
                              }}
                            >
                              <input
                                type="text"
                                id="totalTransDiscountAmount"
                                name="totalTransDiscountAmount"
                                onChange={(e) => onChangeDiscountAmount(e.target.value)}
                                placeholder=""
                                className="form-control"
                                onKeyPress={(e) => handleKeyPress(e)}
                                value={totalTransDiscountAmount}
                                autoComplete="off"
                                style={{
                                  padding: "0 !important",
                                  margin: "0 !important",
                                }}
                                disabled={isConvert || isDuplicate}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {businessSetting.TransactionWiseTax == 1 && (
                        <div className="col-md-12" id="formSideRight">
                          <div className="form-group row">
                            <label
                              style={{
                                textAlign: "right",
                                margin: "0 0 0 0",
                              }}
                              className="col-lg-4 col-form-label"
                              htmlFor="totalAmount"
                            >
                              Tax{" "}
                            </label>
                            <div
                              className="col-lg-4 form-material"
                              id="paddingOff"
                              style={{
                                padding: "0 !important",
                                margin: "0 0 !important",
                              }}
                            >
                              <select
                                style={{ width: "85px" }}
                                className="form-control"
                                onChange={(e) => { onChangeTaxRate(e.target.value) }}
                                value={transactionWiseTaxId}
                                disabled={isConvert || isDuplicate}
                              >
                                {taxRateArray.map((tax, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={tax.id} >
                                      {tax.name + (tax.id == 0 ? '' : "@" + tax.ratio + "%")}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <div
                              className="col-lg-4 form-material"
                              id="paddingOff"
                              style={{
                                padding: "0 !important",
                                margin: "0 !important",
                              }}
                            >
                              <input
                                readOnly="readOnly"
                                type="text"
                                id="totalTransTaxAmount"
                                name="totalTransTaxAmount"
                                placeholder=""
                                className={"form-control "}
                                autoComplete="off"
                                value={totalTransTaxAmount}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {/*Additional Charges */}
                      {businessSetting.TransactionAdditionalChargeEnable ==
                        1 && (
                          <div id="taxDisData">
                            {businessSetting.TransactionAdditionalCharge1Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge1"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge1Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        className="form-control"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge1(e.target.value)}
                                        placeholder=""
                                        value={transAdditionalCharge1}
                                        autoComplete="off"
                                        disabled={isConvert || isDuplicate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {businessSetting.TransactionAdditionalCharge2Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge2"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge2Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge2(e.target.value)}
                                        placeholder=""
                                        className="form-control"
                                        value={transAdditionalCharge2}
                                        autoComplete="off"
                                        style={{
                                          padding: "0 !important",
                                          margin: "0 !important",
                                        }}
                                        disabled={isConvert || isDuplicate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {businessSetting.TransactionAdditionalCharge3Enable ==
                              1 && (
                                <div className="col-md-12" id="formSideRight">
                                  <div className="form-group row">
                                    <label
                                      style={{ textAlign: "right" }}
                                      className="col-lg-4 col-form-label"
                                      htmlFor="TransAdditionalCharge3"
                                    >
                                      {
                                        businessSetting.TransactionAdditionalCharge3Name
                                      }
                                    </label>
                                    <div
                                      className="col-lg-8 form-material"
                                      id="paddingOff"
                                    >
                                      <input
                                        type="text"
                                        className="form-control"
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onChange={(e) => onChangeAdditionalCharge3(e.target.value)}
                                        placeholder=""
                                        value={transAdditionalCharge3}
                                        autoComplete="off"
                                        disabled={isConvert || isDuplicate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                      {/*End Additional Charges */}
                    </div>

                    <div className="col-md-12" id="formSideRight">
                      {
                        isReverseCharge &&
                        <>
                          <div className="form-group row">
                            <label
                              style={{ textAlign: "right" }}
                              className="col-lg-4 col-form-label"
                            >
                              Reverse Charge Tax
                            </label>
                            <div className="col-lg-8 form-material" id="paddingOff">
                              <input
                                type="text"
                                readOnly="readOnly"
                                className="form-control"
                                placeholder=""
                                value={reverseChargeTax}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              style={{ textAlign: "right" }}
                              className="col-lg-4 col-form-label"
                              htmlFor="totalAmount"
                            >
                              Payable Amount
                            </label>
                            <div className="col-lg-8 form-material" id="paddingOff">
                              <input
                                type="text"
                                readOnly="readOnly"
                                className="form-control"
                                placeholder=""
                                value={payableAmount}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </>
                      }
                      <div className="form-group row">
                        <label
                          style={{ textAlign: "right" }}
                          className="col-lg-4 col-form-label"
                          htmlFor="totalAmount"
                        >
                          Total Amount
                        </label>
                        <div className="col-lg-8 form-material" id="paddingOff">
                          <input
                            type="text"
                            readOnly="readOnly"
                            className="form-control"
                            placeholder=""
                            value={totalAmount}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div >
                          <div className="form-group row">
                            <label
                              style={{ textAlign: "right" }}
                              className="col-lg-4 col-form-label"
                            >
                              Paid Amount
                            </label>
                            <div
                              className="col-lg-8 form-material"
                              id="paddingOff"
                            >

                              <input
                                type="text"
                                className="form-control"
                                onKeyPress={(e) => handleKeyPress(e)}
                                placeholder=""
                                value={paidAmount}
                                onChange={(e) => onChangePaidAmount(e.target.value)}
                                autoComplete="off"
                                onWheel={() => document.activeElement.blur()}
                                disabled={isConvert || isDuplicate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              style={{ textAlign: "right" }}
                              className="col-lg-4 col-form-label"
                              htmlFor="dueAmount"
                            >
                              Balance Due
                            </label>
                            <div
                              className="col-lg-8 form-material"
                              id="paddingOff"
                            >
                              <input
                                type="text"
                                readOnly="readOnly"
                                className="form-control"
                                id="dueAmount"
                                name="dueAmount"
                                placeholder=""
                                value={dueAmount}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>

                      <div id="additionFields">
                        {(businessSetting.additional_field_check1 == 1) && (
                          <div className="form-group row">
                            <label
                              style={{ textAlign: "right" }}
                              className="col-lg-4 col-form-label"
                              htmlFor="addF1"
                            >
                              {businessSetting.additional_field_name1}
                            </label>
                            <div
                              className="col-lg-8 form-material"
                              id="paddingOff"
                            >
                              <input
                                type="text"
                                className="form-control"
                                id="additional_value_1"
                                name="additional_value_1"
                                placeholder=""
                                value={additionalValue1}
                                autoComplete="off"
                                disabled={isConvert || isDuplicate}
                                onChange={(e) => setAdditionalValue1(e.target.value)}
                              />
                            </div>
                          </div>
                        )}

                        {(businessSetting.additional_field_check2 == 1 ||
                          businessSetting.additional_field_check2 ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addF2"
                              >
                                {businessSetting.additional_field_name2}
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  id="additional_value_2"
                                  name="additional_value_2"
                                  placeholder=""
                                  value={additionalValue2}
                                  autoComplete="off"
                                disabled={isConvert || isDuplicate}
                                  onChange={(e) => setAdditionalValue2(e.target.value)}
                                />
                              </div>
                            </div>
                          )}

                        {(businessSetting.additional_field_check3 == 1 ||
                          businessSetting.additional_field_check3 ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addF3"
                              >
                                {businessSetting.additional_field_name3}
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  id="additional_value_3"
                                  name="additional_value_3"
                                  placeholder=""
                                  value={additionalValue3}
                                  autoComplete="off"
                                disabled={isConvert || isDuplicate}
                                  onChange={(e) => setAdditionalValue3(e.target.value)}
                                />
                              </div>
                            </div>
                          )}
                        {(businessSetting.additional_field_date_field_check ===
                          1 ||
                          businessSetting.additional_field_date_field_check ===
                          true) && (
                            <div className="form-group row">
                              <label
                                style={{ textAlign: "right" }}
                                className="col-lg-4 col-form-label"
                                htmlFor="addFDate"
                              >
                                {
                                  businessSetting.additional_field_date_field_name
                                }
                              </label>
                              <div
                                className="col-lg-8 form-material"
                                id="paddingOff"
                              >
                                {viewAdditionalDate()}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {businessSetting.TransportationDetailsField1Enable == 1 && (
                // Transportation Detail Here
                // <QuickTransportationDetails />
                <div className="col-md-12">
                  <div className="block block-transparent">
                    <div className="block-content">
                      <h5 className="content-heading">
                        Transportation Details
                      </h5>
                      <div className="block">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="block block-transparent">
                              <div className="block-content" id="formSideLeft">
                                <div className="form-group row">
                                  {businessSetting.TransportationDetailsField1Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField1Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField1"
                                            id="TransportDetailField1"
                                            value={transportDetailField1}
                                            disabled={isConvert || isDuplicate}
                                            onChange={(e) => setTransportDetailField1(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField1Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField2Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField2Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField2"
                                            id="TransportDetailField2"
                                            value={
                                              transportDetailField2
                                            }
                                            disabled={isConvert || isDuplicate}
                                            onChange={(e) => setTransportDetailField2(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField2Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField3Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField3Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField3"
                                            id="TransportDetailField3"
                                            value={
                                              transportDetailField3
                                            }
                                            disabled={isConvert || isDuplicate}
                                            onChange={(e) => setTransportDetailField3(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField3Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField4Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField4Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField4"
                                            id="TransportDetailField4"
                                            value={
                                              transportDetailField4
                                            }
                                            disabled={isConvert || isDuplicate}
                                            onChange={(e) => setTransportDetailField4(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField4Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField5Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField5Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField5"
                                            id="TransportDetailField5"
                                            value={
                                              transportDetailField5
                                            }
                                            disabled={isConvert || isDuplicate}
                                            onChange={(e) => setTransportDetailField5(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField5Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {businessSetting.TransportationDetailsField6Enable ==
                                    1 && (
                                      <div className="col-4">
                                        <div className="form-material open">
                                          <input
                                            type="text"
                                            className="form-control search-box"
                                            placeholder={
                                              businessSetting.TransportationDetailsField6Name
                                            }
                                            autoComplete="off"
                                            name="TransportDetailField6"
                                            id="TransportDetailField6"
                                            value={
                                              transportDetailField6
                                            }
                                            disabled={isConvert || isDuplicate}
                                            onChange={(e) => setTransportDetailField6(e.target.value)}
                                          />
                                          <label htmlFor="login-username">
                                            {
                                              businessSetting.TransportationDetailsField6Name
                                            }
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {!isReadOnly && (
                <div className="col-md-12">
                  <div className="row justify-content-center text-right">
                    <div className="col-lg-9">
                      <button
                        type="submit"
                        onClick={() => clickToAddPurchase()}
                        className="btn btn-alt-primary mb-10 mx-5"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <><i className="fa fa-spinner fa-spin mr-5"></i> Saving...</>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          }

        </div>
        </fieldset>
      </div>
      {isDialogOpen_AddTerms && (
        <Dialog title={'Due Dates and Payment terms'} onClose={() => setIsDialogOpen_AddTerms(false)}>
          <QuickAdjustAddNewTerms
            callBack={(data) => onCallbackAddTerms(data)}
            callBackTerms={() => {
              setIsDialogOpen_AddTerms(false);
            }}
          />
        </Dialog>
      )}
      {
        isDialogOpen_AddPrefix && (
          <Dialog width={500} title={'Add New Prefix'} onClose={() => setIsDialogOpen_AddPrefix(false)}>
            <QuickAddNewPrefix
              callBack={(newPrefixId, newPrefixName) => onCallbackAddPrefix(newPrefixId, newPrefixName)}
              transactionType="PURCHASE"
            />

          </Dialog>
        )
      }
      {
        isDialogAddNewParty && (
            <Dialog  width={'50%'} height={600}  title={'Add New Party'} onClose={() => setIsDialogAddNewParty(false)}>

                <QuickAddNewParty isRedirectTo={"business/add-purchase/"} />

            </Dialog>
        )
      }
      {
        isDialogAddNewBank && (
            <Dialog  width={'70%'}  title={'Add New Bank'} onClose={() => setIsDialogAddNewBank(false)}>

                <QuickAddNewBankDetail
                  callBack={() => {
                    getBankListData(companyId);
                    setIsDialogAddNewBank(false);
                  }} />

            </Dialog>
        )
      }
      {
        isDialogPreviewImage && (
          <Dialog width={'70%'} height={'70%'} title={'Preview'} onClose={() => setIsDialogPreviewImage(false)}>
              <img
                style={{
                  width: "100%", 
                  height: "100%", 
                  objectFit: "contain"
                }}
                className="preview"
                src={imagePreviewUrl}
                alt={"image-"}
                key="13213"
              />

          </Dialog>
        )
      }
      {
        isLoading && (
          <Dialog >
            <Loader type="converging-spinner" />
          </Dialog>
        )
      }
      {
        showSuccessDialog &&
        <TransactionCreateDialog
          onPreview={() => {
            setShowSuccessDialog(false);

            window.location.href = global.webUrl + "business/PurchasePdfDialog/?new=true&auth=" + transactionId;
          }}
          closeText={isEditMode ? 'Re Edit' : 'Add More'}
          onClose={() => {
            window.location.reload();
          }}
          onBack={() => {
            history.goBack();
          }}
          title={'Success'}
          message={message}
        />
      }

    </div>
  );
}
export default ManagePurchaseCreate